import * as React from 'react'

import getConfig from 'next/config'

export const SoclozScript = () => {
  const {
    publicRuntimeConfig: { socloz },
  } = getConfig()

  return (
    <script
      defer
      id="soclozjs"
      src={socloz.srcUrl}
      data-socloz-app_key={socloz.appKey}
      data-socloz-country="FR"
      data-socloz-locale="fr_FR"
    />
  )
}
